import {FormRadioType} from '../../../../blocks/FormBlock'
import {copy} from '../../../../../util/fieldscopy'

const genderField: FormRadioType = {
	id: 0,
	parent_id: 0,
	channel: 'radio',
	label: copy?.gender || 'Genderidentiteit',
	name: 'gender',
	required: true,
	options: [
		{
			amount: null,
			path: 'm',
			title: copy?.gender_male || 'm'
		},
		{
			amount: null,
			path: 'f',
			title: copy?.gender_female || 'v'
		},
		{
			amount: null,
			path: 'x',
			title: copy?.gender_unknown || 'x'
		}
	]
}

export default genderField
